import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

const CATEGORIES = [
  { key: 'faculty_staff', label: 'Faculty / Staff' },
  { key: 'dependent', label: 'Dependants' },
  { key: 'non_dependent', label: 'Non-dependants (default)' },
  { key: 'other', label: 'Others' },
];

const AFFILIATIONS = [
  { key: 'faculty_staff_relative', label: 'Relative to faculty/staff' },
  { key: 'guest', label: 'Guest' },
  { key: 'project_staff', label: 'Project Staff' },
  { key: 'intern', label: 'Interns' },
  { key: 'contractor', label: 'Contractor' },
  { key: 'other', label: 'Other affiliation' },
];

/** OPD tariffs by patient category and affiliation. Zero fee = no payment step. */
export default function ClinicTariffConfigForm({ form, setForm }) {
  const setCat = (key, value) => setForm((f) => ({
    ...f, categories: { ...f.categories, [key]: Number(value) },
  }));
  const setAff = (key, value) => setForm((f) => ({
    ...f, affiliations: { ...f.affiliations, [key]: Number(value) },
  }));

  return (
    <div className="space-y-6" data-testid="clinic-tariff-config-form">
      <p className="text-[12px] text-zinc-500 leading-relaxed rounded-xl border border-zinc-200 bg-zinc-50 px-4 py-3">
        ₹0 for a patient type means the appointment is confirmed without collecting payment.
        Positive amounts are collected at reception during triage before the doctor queue.
      </p>

      <div>
        <p className="text-sm font-semibold text-[#071B34]">Category tariffs (₹)</p>
        <p className="text-[12px] text-zinc-500 mb-3">Base fee by patient type</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {CATEGORIES.map((c) => (
            <div key={c.key} className="space-y-1">
              <Label htmlFor={`cat-${c.key}`}>{c.label}</Label>
              <Input
                id={`cat-${c.key}`}
                type="number"
                min={0}
                step={1}
                value={form.categories?.[c.key] ?? 0}
                onChange={(e) => setCat(c.key, e.target.value)}
                data-testid={`tariff-cat-${c.key}`}
              />
            </div>
          ))}
        </div>
      </div>

      <div>
        <p className="text-sm font-semibold text-[#071B34]">Affiliation tariffs (₹)</p>
        <p className="text-[12px] text-zinc-500 mb-3">
          Override for non-dependants by affiliation (guest, intern, etc.)
        </p>
        <div className="grid sm:grid-cols-2 gap-3">
          {AFFILIATIONS.map((a) => (
            <div key={a.key} className="space-y-1">
              <Label htmlFor={`aff-${a.key}`}>{a.label}</Label>
              <Input
                id={`aff-${a.key}`}
                type="number"
                min={0}
                step={1}
                value={form.affiliations?.[a.key] ?? 0}
                onChange={(e) => setAff(a.key, e.target.value)}
                data-testid={`tariff-aff-${a.key}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
